const GRAPHQL_ENDPOINT = '/api/landings/magento?path=/graphql';

export async function executeQuery(query, variables = {}) {
	const response = await fetch(GRAPHQL_ENDPOINT, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		credentials: 'include',
		body: JSON.stringify({
			query,
			variables
		}),
	});

	if (!response.ok) {
		return null;
	}

	const result = await response.json();
	
	if (result.errors) {
		return null;
	}

	return result.data;
}

export async function createEmptyCart() {
	const query = `
		mutation {
			createEmptyCart
		}
	`;

	const result = await executeQuery(query);
	return result.createEmptyCart;
}

export async function getProducts(skus) {
	const query = `
		query GetProducts($skus: [String!]!) {
			products(filter: { sku: { in: $skus } }) {
				items {
					sku
					name
					mindbox_id
					special_price
					price: price_range {
						maximum_price {
							final_price {
								value
								currency
							}
						}
					}
					stock_status
					__typename
					... on ConfigurableProduct {
						variants {
							product {
								sku
								name
								mindbox_id
								special_price
								price: price_range {
									maximum_price {
										final_price { value currency }
									}
								}
								stock_status
							}
						}
					}
				}
			}
		}
	`;

	const result = await executeQuery(query, { skus });
	const items = result?.products?.items || [];
	const flattened = [];

	for (const item of items) {
		flattened.push(item);
		if (item?.variants?.length) {
			for (const variant of item.variants) {
				if (variant?.product) {
					flattened.push(variant.product);
				}
			}
		}
	}

	const requestedSkuSet = new Set(skus.map(String));
	const exactMatches = flattened.filter(p => requestedSkuSet.has(String(p.sku)));
	const orderMap = skus.reduce((acc, sku, index) => {
		acc[String(sku)] = index;
		return acc;
	}, {});

	exactMatches.sort((a, b) => orderMap[String(a.sku)] - orderMap[String(b.sku)]);
	return exactMatches;
}

export async function addProductToCart(cartId, sku, quantity = 1) {
	const query = `
		mutation AddProductToCart($cartId: String!, $sku: String!, $quantity: Float!) {
			addSimpleProductsToCart(
				input: {
					cart_id: $cartId,
					cart_items: [
						{
							data: {
								quantity: $quantity,
								sku: $sku
							}
						}
					]
				}
			) {
				cart {
					items {
						id
						product {
							sku
							name
						}
						quantity
					}
				}
			}
		}
	`;

	const variables = {
		cartId,
		sku,
		quantity
	};

	return executeQuery(query, variables);
}